import { useMemo } from 'react';

import { Text } from '@/_components';
import {
  getInvoiceEmailRecipients,
  type InvoiceEmailRecipient,
} from '@/_pages/invoices/shared/get-invoice-email-recipients';
import type { InvoiceQuerySchema } from '@/_pages/invoices/shared/schemas';

type InvoiceDetailsEmailToSectionProps = {
  invoice: InvoiceQuerySchema;
};

function EmailToEntry({ recipient }: { recipient: InvoiceEmailRecipient }) {
  return (
    <div className="min-w-0">
      <Text className="text-c-card-muted text-[10px] leading-tight">{recipient.name}</Text>
      <Text className="text-c-card-foreground mt-0.5 text-xs font-medium break-all">
        {recipient.email ?? 'No email on file'}
      </Text>
    </div>
  );
}

export function InvoiceDetailsEmailToSection({ invoice }: InvoiceDetailsEmailToSectionProps) {
  const recipients = useMemo(() => getInvoiceEmailRecipients(invoice), [invoice]);

  return (
    <div>
      <Text className="text-c-card-muted mb-1 text-[10px] font-semibold tracking-wide uppercase">Email To</Text>
      <div className="border-c-border rounded border p-2">
        {recipients.length === 0 ? (
          <Text className="text-c-card-muted text-xs">—</Text>
        ) : (
          <div className="space-y-3">
            {recipients.map((recipient) => (
              <EmailToEntry key={recipient.id} recipient={recipient} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
